import { render } from "./Content.vue?vue&type=template&id=0fa194a6"
const script = {}

import "./Content.vue?vue&type=style&index=0&id=0fa194a6&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__